module.exports = __webpack_public_path__ + "static/body-4ea0a0fbcb5eed1e8b63a4fbbcc0890e.png";